export function isPinned(shouldPinFirstRow: boolean | number, rowIndex: number): boolean {
  return rowIndex < Number(shouldPinFirstRow);
}
